namespace PaperTrail.NewsletterControl {
    export interface NewsSectionRow {
        NewsSectionId?: number;
        Title?: string;
        Content?: string;
        ImageBytes?: number[];
        NewsletterPageTemplateId?: number;
        NewsletterPageTemplateNewsletterId?: number;
        NewsletterPageTemplatePageTemplateId?: number;
    }

    export namespace NewsSectionRow {
        export const idProperty = 'NewsSectionId';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'NewsletterControl.NewsSection';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            NewsSectionId = "NewsSectionId",
            Title = "Title",
            Content = "Content",
            ImageBytes = "ImageBytes",
            NewsletterPageTemplateId = "NewsletterPageTemplateId",
            NewsletterPageTemplateNewsletterId = "NewsletterPageTemplateNewsletterId",
            NewsletterPageTemplatePageTemplateId = "NewsletterPageTemplatePageTemplateId"
        }
    }
}
